export enum Reason {
  no_partner = 'no_partner',
  no_account = 'no_account',
  not_user_account = 'not_user_account',
  same_user = 'same_user',
  blocked_partner = 'blocked_partner',
  blocked_trader = 'blocked_trader',
  bonus_account = 'bonus_account',
  wrong_account_tariff = 'wrong_account_tariff',
  archived_account = 'archived_account',
  demo_account = 'demo_account',
  detached_by_fraud = 'detached_by_fraud'
}

export interface PartnerState {
  isAttached: boolean;
  partnerLogin: number;
  partnerUserId: number;
  partnerCountry: string;
  canAttach: boolean;
  restrictedAttachReason: Reason[];
  referralId: number;
  rebatePercent: number;
}

export interface AttachPartnerRequest {
  partnerLogin: number;
  accountLogin: number;
}

export enum AttachErrorsEnum {
  periodOverAttaching = 'PERIOD_OVER_ATTACHING_ERROR', // - В течение 7 дней после открытия счета,
  // если по счету есть торговая история;
  attemptsReachedAttaching = 'ATTEMPTS_REACHED_ATTACHING_ERROR', // - При наличии торговой истории,
  // если история прикрепления содержит не больше одной записи (в течение первых 7 дней после открытия счета при наличии
  // торговой истории клиент имеет право сменить партнера 1 раз);
  invalidPartnerAttaching = 'INVALID_PARTNER_ATTACHING_ERROR', //- если пользователь вводит некорретный
  // (не существующий, заблокированный, не являющийся партнерским) номер счета,
  // привязка не происходит и отображается соответствующая ошибка;
  selfAttaching = 'SELF_ATTACH_ATTACHING_ERROR',// - если пользователь вводит номер собственного партнерского
  // счета,привязка не происходит и отображается соответствующая ошибка;
  cardVerificationAttaching = 'CARD_VERIFICATION_ATTACHING_ERROR', //- когда у клиента карточный деп на проверке.
  partnerBlacklistedReferralAttachments = 'PARTNER_BLACKLISTED_REFERRAL_ATTACHMENTS_ERROR', // - когда партнер, к которому прикрепляется, в черном списке
  partnerNotAvailableBecausePartnership = 'PARTNER_NOT_AVAILABLE_BECAUSE_PARTNERSHIP_ERROR', // - когда партнер пытается привязать торговый счетов, когда уже привязан как партнер к партнеру
}
